import React from "react";
import { Text } from "app/components/FormikField";
import PropTypes from "prop-types";
import { GridStyled } from "./EmployeeTypes.styles";
const EmployeeTypeForm = (props) => {
  const { descriptionCharacterLimit } = props;
  return /* @__PURE__ */ React.createElement(GridStyled, { container: true, spacing: 2 }, /* @__PURE__ */ React.createElement(GridStyled, { item: true, xs: 6 }, /* @__PURE__ */ React.createElement(
    Text,
    {
      field: {
        type: "text",
        name: "name",
        header: "owners.settings.employeeType",
        required: true
      }
    }
  )), /* @__PURE__ */ React.createElement(GridStyled, { item: true, xs: 12 }, /* @__PURE__ */ React.createElement(
    Text,
    {
      field: {
        type: "text",
        name: "description",
        header: "description",
        multiline: true,
        minRows: 4,
        characterCounterEnabled: true,
        options: {
          max: descriptionCharacterLimit
        }
      }
    }
  )));
};
EmployeeTypeForm.propTypes = {
  initialValues: PropTypes.object
};
export default EmployeeTypeForm;
